// import Card from "components/card";

// const Widget = ({ icon, title, subtitle }) => {
//   return (
//     <Card extra="!flex-row flex-grow items-center rounded-[20px]">
//       <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
//         <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
//           <span className="flex items-center text-brand-500 dark:text-white">
//             {icon}
//           </span>
//         </div>
//       </div>

//       <div className="h-50 ml-4 flex w-auto flex-col justify-center">
//         <p className="font-dm text-sm font-medium text-gray-600">{title}</p>
//         <h4 className="text-xl font-bold text-navy-700 dark:text-white">
//           {subtitle}
//         </h4>
//       </div>
//     </Card>
//   );
// };

// export default Widget;



import Card from "components/card";

const Widget = ({ icon, title, subtitle, colorVariant = "default" }) => {
  
  const colorVariants = {
    default: {
      card: "bg-gradient-to-r from-yellow-400 to-yellow-500",
      iconBg: "bg-yellow-600",
      iconColor: "text-white",
      titleColor: "text-yellow-100",
      subtitleColor: "text-white"
    },
    amber: {
      card: "bg-gradient-to-r from-amber-400 to-amber-500",
      iconBg: "bg-amber-600", 
      iconColor: "text-white",
      titleColor: "text-amber-100",
      subtitleColor: "text-white"
    },
    orange: {
      card: "bg-gradient-to-r from-orange-400 to-orange-500",
      iconBg: "bg-orange-600",
      iconColor: "text-white", 
      titleColor: "text-orange-100",
      subtitleColor: "text-white"
    },
    gold: {
      card: "bg-gradient-to-r from-yellow-500 to-yellow-600",
      iconBg: "bg-yellow-700",
      iconColor: "text-white",
      titleColor: "text-yellow-100", 
      subtitleColor: "text-white"
    }
  };

  const colors = colorVariants[colorVariant];

  return (
    <Card extra={`!flex-row flex-grow items-center rounded-[20px] ${colors.card} shadow-lg border-0`}>
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className={`rounded-full ${colors.iconBg} p-3 shadow-md`}>
          <span className={`flex items-center ${colors.iconColor}`}>
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center">
        <p className={`font-dm text-sm font-medium ${colors.titleColor}`}>{title}</p>
        <h4 className={`text-xl font-bold ${colors.subtitleColor}`}>
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;